'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAgentResponderIfNecessary = undefined;

var _senderTypeToAgentType = require('conversations-schema/operators/sender-type/senderTypeToAgentType');

var _fetchAgentResponder = require('../responders/actions/fetchAgentResponder');

var _getResponderByIdAndType = require('../responders/operators/getResponderByIdAndType');

var _getResponders = require('../responders/selectors/getResponders');

var _getSessionId = require('../selectors/widgetDataSelectors/getSessionId');

var fetchAgentResponderIfNecessary = exports.fetchAgentResponderIfNecessary = function fetchAgentResponderIfNecessary(_ref) {
  var senderId = _ref.senderId,
      senderType = _ref.senderType;

  return function (dispatch, getState) {
    var responders = (0, _getResponders.getResponders)(getState());
    if (!senderId || (0, _getResponderByIdAndType.getResponderByIdAndType)({
      responders: responders,
      senderId: senderId,
      senderType: senderType
    })) {
      return;
    }
    var agentType = (0, _senderTypeToAgentType.senderTypeToAgentType)(senderType);

    dispatch((0, _fetchAgentResponder.fetchAgentResponder)({
      senderId: senderId,
      agentType: agentType,
      sessionId: (0, _getSessionId.getSessionId)(getState())
    }));
  };
};